import React from 'react'

const Notification = () => {
  return (
    <div className='site-info'>Site under construction...</div>
  )
}

export default Notification